import React from 'react';

import PropTypes from 'prop-types';

import loadingTireSvg from '../../assets/svg-icons/loading-tire.svg';
import checkmarCircle from '../../assets/svg-icons/checkmark-circle-blue.svg';
import { getImageURL } from '../../utils/helper-functions';

const SimpleLoader = ({ transparent, message, success }) => {
  let loaderClasses = 'app-loader-inner -simple';
  if (transparent) loaderClasses += ' -transparent';
  if (message) loaderClasses += ' -message';
  if (success) loaderClasses += ' -success';

  return (
    <div className={loaderClasses}>
      {
        success
          ? <img src={getImageURL(checkmarCircle)} alt="Cargando" />
          : <img src={getImageURL(loadingTireSvg)} alt="Cargando" />
      }
      {message && <p className="mt-50">{message}</p>}
    </div>
  );
};

SimpleLoader.defaultProps = {
  message: '',
  transparent: false,
  success: false,
};

SimpleLoader.propTypes = {
  transparent: PropTypes.bool,
  message: PropTypes.string,
  success: PropTypes.bool,
};

export default SimpleLoader;
